import React from "react";
import { Bars } from "react-loader-spinner";
import './loader.css';

const Loaderspinner = () => {
  return (
    <>
      <div className="loader-container d-flex justify-content-center align-items-center">
        <Bars
          height="80"
          width="80"
          color="#99663A"
          ariaLabel="bars-loading"
          wrapperStyle={{}}
          wrapperClass=""
          visible={true}
        />
      </div>
    </>


  );
};

export default Loaderspinner;
